// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"43924924","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};